import React, { createContext, useContext, useEffect, useState } from "react";

import {
  get_religios,
  get_country_list,
  get_level1_caste,
  get_communities,
  get_marital_status,
  get_skin_tone,
  get_physical_build,
  get_habits,
  get_hobbies,
  get_qualification,
  get_language,
  get_relations,
  get_client_relations,
  get_commmunity_docs,
  get_all_castes,
  get_all_countries,
} from "../api/serverWrapper";

// Create Context
const MasterDataContext = createContext();

// Custom Hook
export const useMasterData = () => useContext(MasterDataContext);

export const MasterDataProvider = ({ children }) => {
  const [masterLoading, setMasterLoading] = useState(true);

  const [religionMasterData, setReligionMasterData] = useState([]);
  const [countryMasterData, setCountryMasterData] = useState([]);
  const [casteMasterData, setCasteMasterData] = useState([]);
  const [allCasteMasterData, setAllCasteMasterData] = useState([]);
  const [communityMasterData, setCommunityMasterData] = useState([]);
  const [maritalStatusMasterData, setMaritalStatusMasterData] = useState([]);
  const [skinToneMasterData, setSkinToneMasterData] = useState([]);
  const [buildMasterData, setBuildMasterData] = useState([]);
  const [habitsMasterData, setHabitsMasterData] = useState([]);
  const [hobbiesMasterData, setHobbiesMasterData] = useState([]);
  const [qualificationMasterData, setQualificationMasterData] = useState([]);
  const [languageMasterData, setLanguageMasterData] = useState([]);
  const [relationsMasterData, setRelationsMasterData] = useState([]);
  const [clientRelationsMasterData, setClientRelationsMasterData] = useState([]);
  const [communityDocsMasterData, setCommunityDocsMasterData] = useState([]);
  const [allCountyMasterData,setAllCountyMasterData] = useState([])
  const [selectedCountryCode, setSelectedCountryCode] = useState("91");

  useEffect(() => {
    loadMasterData();
  }, []);

  const loadMasterData = async () => {
    try {
      const [
        religion,
        country,
        caste,
        allcaste,
        community,
        status,
        skinTone,
        build,
        habits,
        hobbies,
        qualification,
        language,
        relations,
        clientRelations,
        commDocs,
        allcountries,
      ] = await Promise.all([
        get_religios(),
        get_country_list(),
        get_level1_caste(),
        get_all_castes(),
        get_communities(),
        get_marital_status(),
        get_skin_tone(),
        get_physical_build(),
        get_habits(),
        get_hobbies(),
        get_qualification(),
        get_language(),
        get_relations(),
        get_client_relations(),
        get_commmunity_docs(),
        get_all_countries(),
      ]);

      setReligionMasterData(religion?.data || []);
      setCountryMasterData(country?.data || []);
      setCasteMasterData(caste?.data || []);
      setAllCasteMasterData(allcaste?.data || []);
      setCommunityMasterData(community?.data || []);
      setMaritalStatusMasterData(status?.data || []);
      setSkinToneMasterData(skinTone?.data || []);
      setBuildMasterData(build?.data || []);
      setHabitsMasterData(habits?.data || []);
      setHobbiesMasterData(hobbies?.data || []);
      setQualificationMasterData(qualification?.data || []);
      setLanguageMasterData(language?.data || []);
      setRelationsMasterData(relations?.data || []);
      setClientRelationsMasterData(clientRelations?.data || []);
      setCommunityDocsMasterData(commDocs?.data || []);
      setAllCountyMasterData(allcountries?.data || [])
    } catch (e) {
      console.error("Master data load failed", e);
    } finally {
      setMasterLoading(false);
    }
  };

  return (
    <MasterDataContext.Provider
      value={{
        religionMasterData,
        countryMasterData,
        casteMasterData,
        allCasteMasterData,
        communityMasterData,
        maritalStatusMasterData,
        skinToneMasterData,
        buildMasterData,
        habitsMasterData,
        hobbiesMasterData,
        qualificationMasterData,
        languageMasterData,
        relationsMasterData,
        clientRelationsMasterData,
        communityDocsMasterData,
        allCountyMasterData,
        masterLoading,
        selectedCountryCode,
        setSelectedCountryCode,
      }}
    >
      {children}
    </MasterDataContext.Provider>
  );
};
